"use client";
import type { HoverData } from "@casino/server/helpers/getHoverData";
import HoverDataContext from "./HoverDataContext";

type Props = { initial: HoverData };

const HoverDataProvider: FC<Props> = ({ initial, children }) => (
  <HoverDataContext.Provider value={initial}>
    {children}
  </HoverDataContext.Provider>
);

export default HoverDataProvider;
